import * as React from "react";
import * as ReactRedux from "react-redux";

import DocFileCell from "./DocFileCell";
import DocFolderCell from "./DocFolderCell/DocFolderCell";
import * as Media from "react-media";
import WithCurrentUser from "./WithCurrentUser";

import Drawer from "material-ui/Drawer";
import { CSSProperties } from "react";
import {
	actions as profilePageActions,
	selectors as profilePageSelectors,
} from "../reducers/profile_page";

interface ProfilePageTemplateProps {
	locationPath: string;
	children?: any;
	currentUser: any;
	userFetchStatus: string;
	isDrawerOpen: boolean;

	closeDrawer(): any;
}

function isLocationEqual(locationPath: string, path: string): boolean {
	return locationPath === path || locationPath === path + "/";
}

class ProfilePageTemplate extends React.Component<ProfilePageTemplateProps> {
	constructor(props: ProfilePageTemplateProps) {
		super(props);
	}

	componentWillReceiveProps(newProps: ProfilePageTemplateProps) {
		if (newProps.userFetchStatus === "failure") {
			window.location.assign("/login");
		} else if (newProps.userFetchStatus === "") {
			window.location.assign("/");
		}
	}

	render() {
		const {
			userFetchStatus,
			currentUser,
			children,
			locationPath,
			isDrawerOpen,
			closeDrawer,
		} = this.props;

		return (
			<Media query={{ maxWidth: 768 }}>
				{isMobile => (
					<>
						{isMobile && (
							<Drawer
								open={isDrawerOpen}
								width={245}
								docked={false}
								onRequestChange={closeDrawer}
								children={
									<ProfilePageNavigator
										locationPath={locationPath}
										userFetchStatus={userFetchStatus}
										currentUser={currentUser}
										style={{
											top: 0,
										}}
										closeDrawer={closeDrawer}
										isInDrawer
									/>
								}
							/>
						)}

						{!isMobile && (
							<ProfilePageNavigator
								locationPath={locationPath}
								userFetchStatus={userFetchStatus}
								currentUser={currentUser}
								closeDrawer={closeDrawer}
							/>
						)}

						<div
							style={{
								position: "absolute",
								top: isMobile ? "6rem" : "5rem",
								bottom: 0,
								left: isMobile ? 0 : 245,
								right: 0,
								paddingTop: "calc(60px + 1.61em)",
							}}
						>
							{children}
						</div>
					</>
				)}
			</Media>
		);
	}
}

const mapStateToProps = state => ({
	isDrawerOpen: profilePageSelectors.isDrawerOpen(state),
});

const mapDispatchToProps = {
	closeDrawer: profilePageActions.closeDrawer,
};

const ProfilePageTemplateContainer = ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(ProfilePageTemplate);

interface ProfilePageNavigatorProps {
	userFetchStatus: string;
	currentUser: any;
	locationPath: string;
	style?: CSSProperties;
	isInDrawer?: boolean; // whether or not this DocNavigator is loading inside the mobile Drawer
	closeDrawer?(): any;
}

class ProfilePageNavigator extends React.Component<ProfilePageNavigatorProps> {
	render() {
		const {
			userFetchStatus,
			currentUser,
			locationPath,
			style,
			isInDrawer,
			closeDrawer,
		} = this.props;

		return (
			<div
				style={{
					width: 245,
					backgroundColor: "white",
					overflowY: "scroll",
					position: "fixed",
					top: "5rem",
					left: 0,
					bottom: isInDrawer ? 0 : "2rem",
					paddingTop: "60px",
					...style,
				}}
			>
				<div
					style={{
						position: "fixed",
						top: isInDrawer ? 0 : "5rem",
						backgroundColor: "rgb(68, 90, 100)",
						display: "flex",
						flexDirection: "row",
						padding: "0 1.61rem",
						height: "60px",
						width: 245,
					}}
				/>
				<DocFolderCell
					title={
						userFetchStatus === "success"
							? `${currentUser.firstName} ${currentUser.lastName}`
							: "..."
					}
				>
					<DocFileCell
						title="Profile"
						link={"/user"}
						isSelected={isLocationEqual(locationPath, "/user")}
						closeDrawer={closeDrawer}
						isInDrawer={isInDrawer}
					/>
					<DocFileCell
						title="Identity Tokens"
						link={"/user/tokens"}
						isSelected={isLocationEqual(locationPath, "/user/tokens")}
						closeDrawer={closeDrawer}
						isInDrawer={isInDrawer}
					/>
					<DocFileCell
						title="Apps"
						link={"/user/apps"}
						isSelected={isLocationEqual(locationPath, "/user/apps")}
						closeDrawer={closeDrawer}
						isInDrawer={isInDrawer}
					/>
					<DocFileCell
						title="Templates"
						link={"/user/templates"}
						isSelected={isLocationEqual(locationPath, "/user/templates")}
						closeDrawer={closeDrawer}
						isInDrawer={isInDrawer}
					/>
					<DocFileCell
						title="Payment"
						link={"/user/wallet"}
						isSelected={isLocationEqual(locationPath, "/user/wallet")}
						closeDrawer={closeDrawer}
						isInDrawer={isInDrawer}
					/>
				</DocFolderCell>
			</div>
		);
	}
}

export default (props: any) => (
	<WithCurrentUser>
		{(currentUser, userFetchStatus) => (
			<ProfilePageTemplateContainer
				locationPath={props.locationPath}
				children={props.children}
				currentUser={currentUser}
				userFetchStatus={userFetchStatus}
			/>
		)}
	</WithCurrentUser>
);



// WEBPACK FOOTER //
// ./src/components/ProfilePageTemplate.tsx